import { useState } from "react";
import dayjs from "dayjs";
import { Lightbulb } from "lucide-react";
import Panel from "./Panel";

// Markdown from the coaching worker, shown as plain text: strip the syntax
// rather than pull in a renderer for one paragraph.
const plain = (md) => String(md || "")
    .replace(/^#+\s*/gm, "")
    .replace(/\*\*(.*?)\*\*/g, "$1")
    .replace(/[*_`]/g, "")
    .replace(/^\s*[-•]\s+/gm, "• ")
    .trim();

const CoachTip = ({ coaching, loading }) => {
    const [open, setOpen] = useState(false);
    if (!loading && !coaching?.summary_md) return null;
    const text = plain(coaching?.summary_md);
    return (
        <Panel title={coaching?.scope === "team" ? "Coach's tip for the team" : "Coach's tip for you"}
               icon={Lightbulb} loading={loading}
               className="bg-gradient-to-br from-brand-50 to-white dark:from-brand-900/20 dark:to-gray-800">
            <p className={`text-sm text-gray-700 dark:text-gray-200 whitespace-pre-line ${open ? "" : "line-clamp-3"}`}>
                {text}
            </p>
            <div className="flex items-center justify-between mt-2">
                {text.length > 180 ? (
                    <button type="button" onClick={() => setOpen(o => !o)}
                            className="text-xs font-medium text-brand-600 dark:text-brand-300">
                        {open ? "Show less" : "Read more"}
                    </button>
                ) : <span />}
                {coaching?.generated_at && (
                    <span className="text-[11px] text-gray-400">{dayjs(coaching.generated_at).fromNow()}</span>
                )}
            </div>
        </Panel>
    );
};

export default CoachTip;
